import { Price, Unit } from '@product/const';
import { floatNumber } from '@shared/helpers/float-number';

interface ConvertedUnit extends Unit {
  amount: number;
}

export function convertToSaleUnit(price: Price): Unit;
export function convertToSaleUnit(price: Price, amount: number): ConvertedUnit;

export function convertToSaleUnit(price: Price, amount?: number): ConvertedUnit {
  const { saleUnit } = price;
  const ratio = saleUnit.ratio || 1;
  let calculatedAmount: number | undefined;

  if (typeof amount === 'number') {
    // учтена погрешность из-за округления quantity (только int) в целевое кол-во (например м^2, может быть float)
    // округляет к большему целому, 2.01 -> 3, 2.89 -> 3
    const saleUnitAmountRaw = +(amount * ratio).toFixed(1);
    calculatedAmount = Math.ceil(saleUnitAmountRaw);
  }

  return { ...saleUnit, amount: calculatedAmount };
}

export function convertFromSaleUnit(price: Price): Unit;
export function convertFromSaleUnit(price: Price, amount: number): ConvertedUnit;

export function convertFromSaleUnit(price: Price, amount?: number): ConvertedUnit {
  const { saleUnit, unit } = price;
  const ratio = saleUnit.ratio || 1;

  return { ...unit, amount: typeof amount === 'number' ? floatNumber(amount / ratio) : undefined };
}
